import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';

import { RequestsMap } from '../RequestsMap';
import { TrafficMap } from '../TrafficMap';

export const Map = () => {
  const { chainCallProtocol } = useChainSelectors();

  const isGRPC = chainCallProtocol === 'grpc';

  return isGRPC ? <TrafficMap /> : <RequestsMap />;
};
